import { cn } from "@/lib/utils";

interface AuthBackdropProps {
  /**
   * "festive" agrandit et renforce les halos (inscription), "sober" reste discret (connexion).
   * Halos statiques : ils sont peints sous le fond de la page (z-index négatif dans un parent sans
   * contexte d'empilement), donc invisibles aujourd'hui ; leurs boucles de 22 à 30 s tournaient pour rien.
   */
  intensity?: "festive" | "sober";
}

export function AuthBackdrop({ intensity = "sober" }: AuthBackdropProps) {
  const festive = intensity === "festive";

  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden="true">
      {/* Halo primary (haut-gauche) */}
      <div
        className={cn(
          "absolute -top-32 -left-32 rounded-full blur-3xl",
          festive ? "w-[560px] h-[560px] opacity-50" : "w-[420px] h-[420px] opacity-25",
        )}
        style={{ background: "radial-gradient(circle, hsl(var(--primary) / 0.55), transparent 70%)" }}
      />
      {/* Halo accent (bas-droite) */}
      <div
        className={cn(
          "absolute -bottom-40 -right-32 rounded-full blur-3xl",
          festive ? "w-[600px] h-[600px] opacity-50" : "w-[460px] h-[460px] opacity-25",
        )}
        style={{ background: "radial-gradient(circle, hsl(var(--accent) / 0.55), transparent 70%)" }}
      />
      {/* Halo doux (centre) — uniquement festif */}
      {festive && (
        <div
          className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[480px] h-[480px] rounded-full blur-3xl opacity-30"
          style={{ background: "radial-gradient(circle, hsl(330 80% 75% / 0.45), transparent 70%)" }}
        />
      )}
      {/* Grille de points très subtile */}
      <div className="absolute inset-0 bg-dot-grid opacity-[0.18] dark:opacity-[0.12]" />
    </div>
  );
}
